var common = function(){
	// footerInit();
	setTimeout(function(){
		$(window).off('scroll').on('scroll', scrollEvent);
        $(window).trigger('scroll');

		footerEvent();
		cursor();
		headerClass();
		mainHeaderFun();
		
	} , 0);
}

var scrollEvent = function(){
	footerTop();
	
	// 푸터까지 스크롤 시 탑버튼 위치 
	var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();
		
	if (scrollBottom >= $('#footer').height()){
		$('.pageTop').removeClass('on');
	}else {
		$('.pageTop').addClass('on');
	}

}

//header 클래스 추가 및 제거
var headerClass = function(){
	$('#contents').parents('body').find('#header').removeClass('start');
	$('#main').parents('body').find('#header').addClass('start');
}

var mainHeaderFun = function (){
	var check_main = $('body').find('.mainPage').length;

	if (check_main < 1) {
		$('#header').removeClass('main_header');
	}
	else {
		$('#header').addClass('main_header');
	}
}

// 스크롤 시 탑버튼 노출
var footerTop = function(){
	var winTop = $(window).scrollTop();

	if (winTop > 500){
		$('.pageTop').fadeIn();
	}
	else {
		$('.pageTop').fadeOut();
	}
}

// footer 탑버튼 및 패밀리사이트
var footerEvent = function(){
	$('.btn_top').on('mouseenter', function () {
		console.log('enter');
        $(this).addClass('zoom');
    }).on('mouseleave', function () {
        $(this).removeClass('zoom');
    });
    $('.btn_top').off('click').on('click', function () {
        $('body,html').animate({scrollTop: 0}, 800);
        return false;
    });

	$('.familySite').find('.btn_family').on('click',function(){
		$(this).toggleClass('on');
		$(this).siblings('.list').stop().slideToggle(400);
	});
}

var cursor = function(){
	var appendCursor = '<div class="main_cursor"><div class="cursor"><span></span></div></div>';
	$('body').append(appendCursor);
	//커서 이벤트
	var cursor = $('.main_cursor');

	var cursorEvent = function(){
		$('html,body').mousemove(function(e){
			cursor.css({
				top: e.clientY - cursor.height() / 2,
				left: e.clientX - cursor.width() / 2,
			});
		});

		$('.swiper-button-prev').mouseenter(function(){
			cursor.addClass('cursor-left');
		}).mouseleave(function(){
			cursor.removeClass('cursor-left');
		});

		$('.swiper-button-next').mouseenter(function(){
			cursor.addClass('cursor-right');
		}).mouseleave(function(){
			cursor.removeClass('cursor-right');
		});

		$('a, button,label, input[type="text"],textarea').mouseenter(function(){
			cursor.removeClass('link');
			cursor.addClass('link');
		}).mouseleave(function(){
			cursor.removeClass('link');
		});
	};
	
	cursorEvent();
}

// var footerInit = function(){
// 	if ($('#contents').hasClass("mainPage")) {
// 		$('#footer').addClass('mainfooter');
// 	}
// }

// 팝업오픈
var layerPopControl = function(popName){
	// $('body, html').css('overflow','hidden');
	$this = $('.g_popup[data-pop='+ popName + ']')

	$this.find('.wrap_pop').fadeIn(300);
	$this.find('.dim_full').fadeIn(300);

	$this.find('.btn_pop_close').off("click").on('click', function(){
		popClose(popName);
	});
}

// 팝업닫힘
var popClose = function(popName){
	// $('body, html').css('overflow','inherit');
	$this = $('.g_popup[data-pop='+ popName + ']');
	$this.find('.dim_full, .wrap_pop').fadeOut(300);
}
